export const quoteCommon = {
  label: {
    name: 'Nom',
    validFrom: 'Valide du',
    validTo: 'Valide au',
    contractor: 'Entrepreneur',
    requestedDeliveryDate: 'Date de livraison demandée',
    requestedShipDate: "Date d'expédition demandée",
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    shipComplete: 'Expédier en totalité',
    headerNotes: 'Instruction spéciale',
    referenceQuote: 'Soumission de référence',
    quoteOrderNumber: 'Numéro de soumission',
    status: 'Statut',
    createdBy: 'Créé par',
    creationDate: 'Date de création',
    actions: 'Actions',
    totalQuantity: 'Quantité totale',
    totalItems: "Nombre total d'articles",
    totalPrice: 'Prix total',
    go: 'Aller',
    quote: 'Soumission',
    quoteReference: 'Référence de la soumission',
    downloadPDF: 'Télécharger le PDF',
    addToQuote: 'Ajouter à la soumission',
    createdOn: 'Créé le',
    cancel: 'Annuler',
    downloadCSV: 'Télécharger Excel',
    downloadImages: 'Télécharger les images',
    checkout: 'Accepter et passer la commande',
    saveUpdatedQuote: 'Sauvegarder la soumission mise à jour',
    downloadExcelTemplate: 'Télécharger le gabarit Excel',
    fillFromStock: 'Remplir à partir de mon inventaire',
    hidePrice: 'Masquer le prix',
    showPrice: 'Afficher le prix',
    deleteCart: 'Supprimer la commande provisoire',
  },
  createMessage: {
    success: 'La soumission a été créée avec succès.',
    error: 'Une erreur est survenue lors de la création de la soumission.',
  },
  copyMessage: {
    success: 'La soumission a été copiée avec succès.',
    error: 'Une erreur est survenue lors de la copie de la soumission.',
  },
  updateMessage: {
    success: 'La soumission a été mise à jour avec succès.',
    error: 'Une erreur est survenue lors de la mise à jour de la soumission.',
  },
  checkoutMessage: {
    success: 'La soumission a été acceptée et est prête pour le passage de la commande.',
    error: 'Une erreur est survenue lors de l\'acceptation et du passage de la commande pour la soumission.',
  },
};
export const quoteSearchForm = {
  label: {
    quoteNo: 'Numéro',
    accountNumber: 'Numéro de compte',
    accountName: 'Nom du compte',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    status: 'Statut',
    productNumber: 'Numéro de catalogue',
  },
  placeholder: {
    suggestedQuote: 'Numéro',
  },
};
export const quoteResult = {
  header: {
    quoteNumber: 'Numéro',
    quoteName: 'Nom de la soumission',
    createdBy: 'Créé par',
    creationDate: 'Date de création',
    createdOn: 'Créé le',
    accountNo: 'N° de compte',
    accountName: 'Nom du compte',
    contractorName: "Nom de l'entrepreneur",
    marginOrMarkup: 'Marge / Majoration',
    margin: 'Marge',
    markup: 'Majoration',
    customerPO: 'Bon de commande du client',
    job: 'Travail',
    status: 'Statut',
    validFrom: 'Valide du',
    validTo: 'Valide au',
    total: 'Total',
    actions: 'Actions',
    updateBy: 'Mis à jour par',
  },
  showMore: 'Afficher plus',
  nodataMsg: 'Désolé! Aucune soumission trouvée',
};
export const actionBar = {
  label: {
    quickEntry: 'Saisie rapide',
    searchProducts: 'Rechercher des produits',
  },
};
export const quoteDetailHeader = {
  label: {
    lastUpdatedDate: 'Date de dernière mise à jour',
    reqdeliveryDate: 'Date de livraison demandée',
    revision: 'Révision : ',
  },
  title: {
    addUpdate: 'Ajouter / Modifier la soumission',
  },
};
export const quoteItems = {
  header: {
    productDetails: 'Détails du produit',
    plant: 'Usine',
    reqDeliveryDate: 'Date de livraison demandée',
    reqShipDate: "Date d'expédition demandée",
    listPrice: 'Prix de liste',
    netPrice: 'Prix net',
    availableQty: 'Qté disponible',
    quantity: 'Quantité',
    total: 'Total',
    priceAdjustment: 'Ajustement de prix',
    lineNo: 'N° de ligne',
  },
  placeholder: {
    '1': '1',
  },
};
export const quotePartialItems = {
  header: {
    orderDetails: 'Détails de la commande',
    order: 'Commande',
    item: 'Article',
    product: 'Produit',
    description: 'Description',
    quantity: 'Quantité',
    unit: 'Unité',
    orderDate: 'Date de commande',
  },
};
export const quoteReference = {
  label: {
    quoteNumber: 'Numéro',
    totalQty: 'Qté totale',
    availableQty: 'Qté disponible',
    price: 'Prix',
    jobName: 'Nom du travail',
    referencedQty: 'Qté référencée',
    orderQty: 'Qté commandée',
  },
  referenceNotFound: 'Aucune référence de soumission trouvée pour le produit n° {{ code }}.',
  selectMessage1: 'Le produit n° {{ code }} se trouve dans la soumission suivante',
  selectMessage2: 'Veuillez sélectionner une soumission à référencer dans votre panier.',
};
export const addToQuoteMessage = {
  success: 'Les produits ont été ajoutés à la soumission avec succès.',
  failure: "Échec de l'ajout des produits à la soumission.",
};
